import { SolicitudesService } from './../../../services/solicitudes/solicitudes.service';
import { MessagesTitles, MessagesGeneral, MessagesStatus } from './../../../models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import Swal from "sweetalert2";

@Component({
  selector: 'app-detalle-quejas-reclamos',
  templateUrl: './detalle-quejas-reclamos.component.html',
  styleUrls: ['./detalle-quejas-reclamos.component.scss'],
  providers:[MessagesTitles,MessagesGeneral,MessagesStatus]
})
export class DetalleQuejasReclamosComponent implements OnInit {

  @Output() cerrarPopDetalleReclamo : EventEmitter<boolean> = new EventEmitter();
  formReclamo : FormGroup;
  idSolicitud:any;
  TipoSolicitud_Dsc:any;
  Estado:any;
  Codigo:any;
  data:any;
  viewApoderado:boolean= false;
  panelOpenState = false;
  dataSource:any=[];
  dataRespuesta:any=[];
  repRespuesta:any = [];

  constructor(private solicitudService : SolicitudesService,private msgTitulos : MessagesTitles,private msgStatus:MessagesStatus ) { 
    this.data = solicitudService.datos;
    this.idSolicitud = this.data.idSolicitud;
    this.Codigo = this.data.Codigo;
    this.TipoSolicitud_Dsc = this.data.TipoSolicitud_Dsc ;
    this.Estado = this.data.Estado;
    if (this.data.Edad < 18) {
      this.viewApoderado = true;
    }
  }

  displayedColumns = ['idRespuesta','UsuarioAtencion','Respuesta','Ver'];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.ObtenerListaRespuestas();

    this.formReclamo = new FormGroup({
      NombresCompletos : new FormControl({ value: "", disabled: true }),
      ApellidoPaterno : new FormControl({ value: "", disabled: true }),
      ApellidoMaterno : new FormControl({ value: "", disabled: true }),
      Edad : new FormControl({ value: "", disabled: true }),
      NroDocumentoIdentidad : new FormControl({ value: "", disabled: true }),
      Email : new FormControl({ value: "", disabled: true }),
      TelefonoMovil : new FormControl({ value: "", disabled: true }),
      FechaRegistro : new FormControl({ value: "", disabled: true }),
      TipoSolicitud_Dsc : new FormControl({ value: "", disabled: true }),
      Estado_Dsc : new FormControl({ value: "", disabled: true }),
      Departamento : new FormControl({ value: "", disabled: true }),
      Provincia : new FormControl({ value: "", disabled: true }),
      Distrito : new FormControl({ value: "", disabled: true }),
      Direccion : new FormControl({ value: "", disabled: true}),
      Moneda_Dsc : new FormControl({ value: "", disabled: true }),
      Monto : new FormControl({ value: "", disabled: true }),
      Pedido : new FormControl({ value: "", disabled: true }),
      Detalle : new FormControl({ value: "", disabled: true }),

      NombresCompletos_Apoderado : new FormControl({ value: "", disabled: true}),
      ApellidoPaterno_Apoderado : new FormControl({ value: "", disabled: true }),
      ApellidoMaterno_Apoderado : new FormControl({ value: "", disabled: true }),
      Direccion_Apoderado : new FormControl({ value: "", disabled: true }),
      Email_Apoderado : new FormControl({ value: "", disabled: true }),

    })

      this.formReclamo.controls['NombresCompletos'].setValue(this.data.NombresCompletos);
      this.formReclamo.controls['ApellidoPaterno'].setValue(this.data.ApellidoPaterno);
      this.formReclamo.controls['ApellidoMaterno'].setValue(this.data.ApellidoMaterno);
      this.formReclamo.controls['Edad'].setValue(this.data.Edad);
      this.formReclamo.controls['NroDocumentoIdentidad'].setValue(this.data.NroDocumentoIdentidad);
      this.formReclamo.controls['Email'].setValue(this.data.Email);
      this.formReclamo.controls['TelefonoMovil'].setValue(this.data.TelefonoMovil);
      this.formReclamo.controls['FechaRegistro'].setValue(this.data.FechaRegistro);
      this.formReclamo.controls['TipoSolicitud_Dsc'].setValue(this.data.TipoSolicitud_Dsc);
      this.formReclamo.controls['Estado_Dsc'].setValue(this.data.Estado_Dsc);
      this.formReclamo.controls['Departamento'].setValue(this.data.Departamento);
      this.formReclamo.controls['Provincia'].setValue(this.data.Provincia);
      this.formReclamo.controls['Distrito'].setValue(this.data.Distrito);
      this.formReclamo.controls['Direccion'].setValue(this.data.Direccion);
      this.formReclamo.controls['Moneda_Dsc'].setValue(this.data.Moneda_Dsc);
      this.formReclamo.controls['Monto'].setValue(this.data.Monto);
      this.formReclamo.controls['Pedido'].setValue(this.data.Pedido);
      this.formReclamo.controls['Detalle'].setValue(this.data.Detalle);
      this.formReclamo.controls['NombresCompletos_Apoderado'].setValue(this.data.NombresCompletos_Apoderado);
      this.formReclamo.controls['ApellidoPaterno_Apoderado'].setValue(this.data.ApellidoPaterno_Apoderado);
      this.formReclamo.controls['ApellidoMaterno_Apoderado'].setValue(this.data.ApellidoMaterno_Apoderado);
      this.formReclamo.controls['Direccion_Apoderado'].setValue(this.data.Direccion_Apoderado);
      this.formReclamo.controls['Email_Apoderado'].setValue(this.data.Email_Apoderado);
  }

  ObtenerListaRespuestas(){

    this.solicitudService.ObtenerListadoRespuestas()
          .subscribe( resp => { 
            this.repRespuesta = resp
           this.dataRespuesta =this.filterAccesosOfId();
           this.dataSource = new MatTableDataSource( this.dataRespuesta);
          }, (err: HttpErrorResponse)=> {
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
          } else {
              this.msgStatus.getMessage(err.status);            
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "LISTA ACCESO. no encontrado. "+this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
          })
  }
  filterAccesosOfId(){
    return this.repRespuesta.filter(x => x.idSolicitud== this.idSolicitud);  
  }

  Ver($file:any){
    window.open($file,"_blank");
  }

  CerrarPopUp(){
    this.cerrarPopDetalleReclamo.emit();
  }

}
